import { Container } from "./styles";
import { CalculadorasSelect } from "./CalculadorasSelect";

export const Calculadoras = () => {
  return (
    <Container className="beauty-scrollbar">
      <div className="content">
        <h1>Quais impostos você quer recolher?</h1>
        <CalculadorasSelect />
      </div>
    </Container>
  );
};
